define([
    'text!cooperate/component/item-gallery.html',
    'cooperate/mixin/form'
], function(
    tpl,
    FormMixin
){
    return {
        template: tpl,
        mixins: [FormMixin],
        methods: {
            resetForm: function(){
                this.form = {
                    type: 5,
                    companyName: '',
                    projectName: '',
                    contact: '',
                    tel: '',
                    email: '',
                    companyInfo: '',
                    attch: '',
                    remark: ''
                };
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./cooperate/component/item-gallery.js
// module id = 219
// module chunks = 0